import { render, staticRenderFns } from "./Admincp.vue?vue&type=template&id=a8c1257e&"
import script from "./Admincp.vue?vue&type=script&lang=js&"
export * from "./Admincp.vue?vue&type=script&lang=js&"
import style0 from "./Admincp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports